import { client } from "../config";

export const getKycDetails = async() =>{
    return await client.get('transporter/kyc')
}
export const submitAadhaarDocuments = async(document)=>{
    return await client.post('transporter/kyc/aadhar',document)
}